export default __webpack_public_path__ + "static/media/sati.c4b17e8d.png";